// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gp-0";
export var actionModalContentContainer = "_gp-1";
export var createTagButton = "_gp-2";
export var footerContainer = "_gp-7";
export var fullWidthDivider = "_gp-3";
export var hasCreateTagButton = "_gp-4";
export var noCreateTagButton = "_gp-5";
export var tagsContainer = "_gp-6";
export var tagsModalContentContainer = "_gp-8";